import { z } from '@harvestiq/zod';

export const sendLrpCampaignSmsMessageSchema = z.object({
  campaignId: z.string(),
  orgId: z.string(),
  salesEffectiveDate: z.string().optional(), // This should be used only for manual queuing scripts. Do not actively use it.
});

export type SendLrpCampaignSmsMessage = z.infer<
  typeof sendLrpCampaignSmsMessageSchema
>;
